import { Box, Typography } from '@mui/material';
import React from 'react';
import { match } from 'ts-pattern';

import { EditableValue } from '@/components/molecules/EditableValue';
import {
  ContactDetailsSectionDisplayableEntry,
  ContactDetailsSectionEditableEntry,
  ContactDetailsSectionEntry,
  isContactDetailsSectionEditableEntry,
} from '@/types/contactDetailsSection';

interface Props {
  readonly title: string;
  readonly values: readonly ContactDetailsSectionEntry[];
}

export const ContactDetailsSection: React.FC<Props> = (props: Props): React.ReactElement => {
  const { title, values } = props;

  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Typography variant="body1" color="custom.LightGray">
        {title}
      </Typography>
      {values.map((entry: ContactDetailsSectionEntry): React.ReactNode => {
        return match(entry)
          .when(
            isContactDetailsSectionEditableEntry,
            (entry: ContactDetailsSectionEditableEntry): React.ReactNode => (
              <EditableValue
                key={entry.key}
                label={entry.label}
                value={entry.value}
                displayValue={entry.displayValue}
                input={entry.inputComponent}
                onValidate={entry.validateHandler}
                onUpdate={entry.updateHandler}
              />
            ),
          )
          .otherwise(
            (entry: ContactDetailsSectionDisplayableEntry): React.ReactNode => (
              <Typography key={entry.key} variant="body2" color="text.primary">
                {entry.label ? `${entry.label}: ${entry.displayValue}` : entry.displayValue}
              </Typography>
            ),
          );
      })}
    </Box>
  );
};
